export enum TrailingZeroDisplay {
  Strip = "strip",
  Auto = "auto",
}
